<template>
  <div class="popup-wrapper popup-el"
       :style="`top: ${tooltipProps.position.top}px; left: ${horizontalPosition}px`"
  >
    <div class="rounded-t-lg bg-soft p-3 font-semibold text-black-soft flex justify-between items-center">
      {{ datetime }}
      <div>
        <span class="w-52 truncate">Total requests:</span>
        <span class="font-normal ml-1">{{ totalRequests }}</span>
      </div>
    </div>

    <div class="flex flex-col rounded-b-xl gap-4 py-5 px-4">
      <div v-for="({ legendType, name, data: categoryData }, i) in data" :key="i" class="flex justify-between">
        <div class="flex">
          <chart-legend :type="legendType" :show-label="false" class="mb-1"/>
          <span class="ml-2 mb-1">{{ name }}</span>
        </div>
        <div class="flex">
          <span class="font-semibold">
            {{ getCategoryDetails(categoryData).categoryShare }}
          </span>
          <span class="ml-1">({{ getCategoryDetails(categoryData).categoryCount }})</span>
        </div>
      </div>
    </div>

    <div class="mx-2 py-3 border-0 border-t border-solid border-gray-a10 text-center apexcharts-theme-light">
      <span class="cursor-pointer text-primary-focus font-semibold shadow-btn-primary"
            @click="showDetail"
      >
        Show Answers
      </span>
    </div>

  </div>
</template>

<script>
import intentsUsageTooltipUtils from '@/utils/intents-usage-tooltip.utils'
import ChartLegend from '@/components/analytics/charts/ChartLegend'
import AssistanceResolutionsUtils from '@/utils/assistance-resolutions.utils'

export default {
  name: 'AssistanceResolutionChartTooltip',

  components: {
    ChartLegend
  },

  props: {
    tooltipProps: {
      type: Object,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    axisXValues: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      assistanceResolutionsUtils: {}
    }
  },

  mounted() {
    // ports tooltip alongside of #app in dom, so tooltip position can be calculated based on cursor position in window
    this.$root.$el.append(this.$el)
    // bullet-proof way to tag all elements as part of popup, helpful while stopping
    // mouseleave event of area-chart
    this.$el.querySelectorAll('*').forEach(el => el.classList.add('popup-el'))
  },

  created() {
    this.assistanceResolutionsUtils = new AssistanceResolutionsUtils(this.axisXValues.valueFrom, this.axisXValues.valueTo)
  },

  computed: {
    totalRequests() {
      return intentsUsageTooltipUtils.getCategoryTotal(this.tooltipProps.series, this.tooltipProps.categoryIndex)
    },

    horizontalPosition() {
      return this.tooltipProps.position.movedRight ?
        this.tooltipProps.position.left - this.$el?.clientWidth :
        this.tooltipProps.position.left
    },

    datetime() {
      const timestamp = this.tooltipProps.currentTimestamp
      const periodProps = this.assistanceResolutionsUtils.getPeriodProps(timestamp)
      return this.assistanceResolutionsUtils.getPeriodLabel(periodProps)
    }
  },

  methods: {
    getCategoryDetails(categoryData) {
      const categoryCount = categoryData[this.tooltipProps.categoryIndex]?.[1]
      if (!categoryCount) return { categoryCount: 0, categoryShare: '0%' }

      const categoryShare = `${Math.round(categoryCount / this.totalRequests * 100)}%`
      return { categoryCount, categoryShare }
    },

    showDetail() {
      const resolutionFilterData = {
        categoryIndex: this.tooltipProps.categoryIndex,
        series: this.tooltipProps.series,
        zoomRange: {
          zoomFrom: this.axisXValues.valueFrom,
          zoomTo: this.axisXValues.valueTo,
          currentTimestamp: this.tooltipProps.currentTimestamp
        }
      }
      this.$emit('show-detail', resolutionFilterData)
    }
  }
}
</script>

<style scoped>
.popup-wrapper {
  @apply shadow rounded absolute border border-solid border-soft bg-white text-sm w-90 transition-all	ease-in duration-200;
}
</style>
